export const roundToTwoDecimal = (num) =>
  num ? (Math.round(num * 100) / 100).toFixed(2) : "";

export default roundToTwoDecimal;
